let snapshot;
export function rememberFeed(stories, next) {
  snapshot = {
    stories: [...stories],
    next,
    until: Date.now() + 30000
  };
}
export function feedSnapshot(id) {
  return snapshot && snapshot.until > Date.now() && (!id || snapshot.stories.some(story => story.id === id)) ? snapshot : undefined;
}
export function clearFeedSnapshot() {
  snapshot = undefined;
}
flarum.reg.add('xgay-fact', 'common/feedSnapshot', { rememberFeed: rememberFeed,feedSnapshot: feedSnapshot,clearFeedSnapshot: clearFeedSnapshot, });